
import { defineComponent, ref } from "vue";
import tokenAccess from "@/global/apiAccessToken";
import router from "@/router";
import { fetchAllUserItems } from "@/common/utils/axios";
import userItems from "@/global/userItems";
import currentPageTitle from "@/global/currentPageTitle";

import Item from "@/components/HomeStorageItem.vue";

export default defineComponent({
  name: "HomeView",
  components: {
    Item,
  },
  setup() {
    const token = ref("");
    const items = ref(userItems.getItems);

    return { token, items, router };
  },
  async mounted() {
    const token = await tokenAccess.validateCachedToken();
    if (!token) return router.push("/signin");

    currentPageTitle.setTitle("My storage");
    this.token = token;
    await fetchAllUserItems();
  },
  computed: {
    credentialsCount() {
      return this.items.credentials?.length || 0;
    },
    notesCount() {
      return this.items.notes?.length || 0;
    },
    cardsCount() {
      return this.items.cards?.length || 0;
    },
    wifiCount() {
      return this.items.wifis?.length || 0;
    },
    documentsCount() {
      return this.items.documents?.length || 0;
    },
  },
});
